import { render, staticRenderFns } from "./reviewlist.vue?vue&type=template&id=35a05cf0&scoped=true&"
import script from "./reviewlist.vue?vue&type=script&lang=js&"
export * from "./reviewlist.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./reviewlist.vue?vue&type=style&index=1&id=35a05cf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a05cf0",
  null
  
)

export default component.exports